<template>
  <div class="pa-3 grey lighten-4">
    <v-card class="mt-3">
      <v-card-title class="grey lighten-4 pa-2">
        <h3 class="secondary--text">
          {{$t('company.whitelable.config.active.domains.title')}}
          <v-tooltip top color="white">
            <template v-slot:activator="{ on }">
              <v-icon size="19" v-on="on">mdi-information-outline</v-icon>
            </template>
            <span class="greyDarken3--text body-1"
              >{{$t('company.whitelable.config.active.domains.title.tooltip')}}</span
            >
          </v-tooltip>
        </h3>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text>
        <!-- Payment Source -->
        <v-flex xs12 class="px-3">
          <v-card-text class="heading">
            <v-btn small class="success white--text mr-4">Live</v-btn>
              <a class="title" :href="company.domain" target="_blank"
                >{{ company.domain }}</a
              >
            </v-card-text>
        </v-flex>
        <v-flex v-if="company.whitelabel_status==DEFINES.WHITELABEL_STATUS['REQUESTED']" xs12 class="px-3 pt-2">
          <v-card-text class="heading">
            <v-btn small class="success white--text mr-4">Live</v-btn>
              <a class="title" :href="company.whitelabel_domain" target="_blank"
                >{{ company.whitelabel_domain }}</a
              >
            </v-card-text>
        </v-flex>

      </v-card-text>
    </v-card>
    <!-- Addons -->
    <v-card class="mt-3">
      <v-card-title class="grey lighten-4 pa-2">
        <h3 class="secondary--text">{{$t('company.whitelable.configure')}}</h3>
      </v-card-title>
      <v-card-text class="">
         <v-flex v-if="company" xs12 class="px-3">
          <v-stepper  v-model="step" class="mt-3" vertical>
              <!-- Step-1 : Guide basic information -->
              <v-stepper-step :complete="step > 1" step="1" @click="step = 1">
                {{$t('company.whitelable.configure.step.update_record_to_domain_provider')}}
              </v-stepper-step>
              <v-stepper-content step="1">
                <v-card flat>
                  <v-timeline dense>
                    <v-timeline-item small
                      >{{$t('company.whitelable.configure.step.update_record_to_domain_provider.step_1')}}</v-timeline-item
                    >
                    <v-timeline-item small
                      >{{$t('company.whitelable.configure.step.update_record_to_domain_provider.step_2')}}</v-timeline-item
                    >
                    <v-timeline-item small
                      >{{$t('company.whitelable.configure.step.update_record_to_domain_provider.step_3')}}</v-timeline-item
                    >
                  </v-timeline>
                </v-card>
                <v-btn color="primary" @click="step = 2">
                  Next
                </v-btn>
              </v-stepper-content>
              <!-- Step-2 : Guide DNS record creation -->
              <v-stepper-step :complete="step > 2" step="2" @click="step = 2">
                {{$t('company.whitelable.configure.step.add_record_title')}}
              </v-stepper-step>
              <v-stepper-content step="2">
                <v-card flat class="mb-4">
                  <p>
                    {{$t('company.whitelable.configure.step.add_record.description')}}
                  </p>
                  <p v-html="$t('company.whitelable.configure.step.add_record.important_message')">
                    {{$t('company.whitelable.configure.step.add_record.important_message')}}
                  </p>
                  <v-data-table
                    :headers="headers"
                    :items="IPv4_content"
                    class="elevation-1"
                    hide-actions
                  >
                    <template v-slot:items="props">
                      <td>{{ props.item.name }}</td>
                      <td>{{ props.item.type }}</td>
                      <td>{{ props.item.ttl }}</td>
                      <td>{{ props.item.proxy_status }}</td>
                      <td>
                        {{ props.item.address }}
                        <v-btn small icon text @click="$copyText(props.item.address)">
                          <v-icon small color="success"
                            >$vuetify.icons.rms_copy</v-icon
                          >
                        </v-btn>
                      </td>
                    </template>
                  </v-data-table>
                </v-card>
                <v-btn color="primary" @click="step = 3">
                  Next
                </v-btn>
                <v-btn text @click="step = 1">
                  back
                </v-btn>
              </v-stepper-content>
              <!-- Step-3 : Domain input -->
              <v-stepper-step :complete="step > 3" step="3" @click="step = 3">
                {{$t('company.whitelable.configure.step.update_domain')}}
              </v-stepper-step>
              <v-stepper-content step="3">
                <v-card flat>
                  <v-card-text class="mb-3">
                   {{$t('company.whitelable.configure.step.update_domain.message')}}
                  </v-card-text>
                  <v-form ref="form" onsubmit="return false;">
                    <v-text-field
                      :label="$t('company.whitelable.configure.step.update_domain.input')"
                      placeholder="e.g- example.com"
                      v-model="whitelabelDomain"
                      :rules="[
                        rules.required,
                        rules.max_length(50),
                        rules.min_length(3)
                      ]"
                      validate-on-blur
                      :hint="
                        whitelabelDomain
                          ? protocol+whitelabelDomain
                          : null
                      "
                      outlined
                      :persistent-hint="true"
                    ></v-text-field>
                  </v-form>

                </v-card>
                <div class="mt-2">
                  <v-btn
                    color="primary"
                    @click="updateWhitelabelDomain()"
                  >
                    next
                  </v-btn>
                  <v-btn text @click="step = 2">
                    Back
                  </v-btn>
                </div>
              </v-stepper-content>
              <!-- Step-1 : Guide basic information -->
              <v-stepper-step :complete="step > 4" step="4" @click="step = 4">
                Status
              </v-stepper-step>
              <v-stepper-content step="4">
                <v-card v-if="company && company.whitelabel_status==DEFINES.WHITELABEL_STATUS['REQUESTED']" flat>
                  <v-card-title class="headline">Your part is done!</v-card-title>
                  <v-card-text>
                    {{$t('company.whitelable.configure.step.update_domain.status.requested.message',{
                        whitelabel: protocol+whitelabelDomain
                      })}}
                    <v-text-field

                      :label="'Requested Domain'"
                      :value="protocol+whitelabelDomain"
                      readonly
                      class="mt-2"
                      dense
                      outlined
                    >
                    </v-text-field>
                  </v-card-text>
                </v-card>
                <v-btn text @click="step = 3">
                  Back
                </v-btn>
              </v-stepper-content>
            </v-stepper>
        </v-flex>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import ExistingPaymentMethod from "@/components/ExistingPaymentMethod";
import { mapState, mapGetters } from "vuex";
import PaymentForm from "@/components/PaymentForm";
import AddOns from '@/components/screener/AddOns';
import rules from "@/validation";
import i18n from "@/i18n"

export default {
  name: "CompanyWhiteLabel",
  props: {
    company: {
      type: Object,
      default: null,
    },
  },
  components: {
    ExistingPaymentMethod,
    PaymentForm,
    AddOns
  },
  data() {
    return {
      rules,
      payment_method: null,
      step: this.evaluatedCurrentStep(),
      protocol: this.DEFINES.AVAIL_APP_PROTOCOL,
      headers: [
        { text: "Name", align: "left", value: "name", sortable: false },
        {
          text: "Type",
          sortable: false,
          align: "left",
          value: "type"
        },
        {
          text: "TTL",
          sortable: false,
          align: "left",
          value: "ttl"
        },
        {
          text: "Proxy Status",
          sortable: false,
          align: "left",
          value: "proxy_status"
        },
        {
          text: "Address",
          sortable: false,
          align: "left",
          value: "address"
        }
      ],
      whitelabelDomain: null
    };
  },
  computed: {
    ...mapGetters("company", {
      selected_company_id: "getSelected",
      selected_company: "getSelectedCompany",
    }),
    userRoleInCompany() {
      return this.$store.getters["company/userRoleInCompany"](
        this.selected_company_id
      );
    },
    IPv4_content: function() {
      return [
        {
          name: "@",
          type: "A",
          ttl: "Address",
          proxy_status: "DNS only",
          address: this.DEFINES.WHITELABEL_MACHINE_IP
        },
        // {
        //   name: "www",
        //   type: "CNAME",
        //   ttl: "1H",
        //   proxy_status: "DNS only",
        //   address: this.DEFINES.WHITELABEL_MACHINE_IP
        // }
      ];
    },
  },
  mounted(){
    this.whitelabelDomain = this.company.whitelabel_domain;
    if(this.whitelabelDomain){
      this.whitelabelDomain = this.whitelabelDomain.replace(this.protocol,'');
    }
  },

  methods: {
    async updateWhitelabelDomain(company) {
      if (!this.$refs.form.validate()) {
        return false;
      }

      await this.$store.dispatch("company/updateWhitelabelDomain", {
          whitelabel_domain: this.whitelabelDomain,
      })
      .then((response) => {
        this.company = response.company;
        // this.company.whitelabel_status = response.company.whitelabel_status;
        this.whitelabelDomain = response.company.whitelabel_domain;
        if(this.whitelabelDomain){
          this.whitelabelDomain = this.whitelabelDomain.replace(this.protocol,'');
        }
        this.step = 4;
        this.$store.dispatch("app/showMessage", {
            message: i18n.t("message.success.updated"),
            color: "success",
        });
      })
      .catch((error) => {
          this.$store.dispatch("app/showMessage", {
              message: error.message,
              color: "error",
          });
      })
    },

    evaluatedCurrentStep() {
      if(this.company.whitelabel_status == this.DEFINES.WHITELABEL_STATUS['NOT_CONFIGURED']){
        return 1
      }
      if(this.company.whitelabel_status == this.DEFINES.WHITELABEL_STATUS['REQUESTED']){
        return 4
      }
    }
  },
};
</script>
